// extracted by mini-css-extract-plugin
module.exports = {"modal":"SendForApprovalSummaryModal_modal___Dr4I"};